var cov_2j7u0d7289 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/hash.ts",
      hash = "11f4d7b37e52175f9afd0cc250c6f16297dff0b0",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/hash.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 13
        },
        end: {
          line: 2,
          column: 14
        }
      },
      "1": {
        start: {
          line: 8,
          column: 15
        },
        end: {
          line: 8,
          column: 25
        }
      },
      "2": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "3": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 31
        }
      },
      "4": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 11
        }
      },
      "5": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 15
        }
      },
      "6": {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 11
        }
      },
      "7": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 18,
          column: 37
        }
      },
      "8": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 11
        }
      },
      "9": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "10": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 37
        }
      },
      "11": {
        start: {
          line: 23,
          column: 26
        },
        end: {
          line: 23,
          column: 37
        }
      },
      "12": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 30,
          column: 5
        }
      },
      "13": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 29
        }
      },
      "14": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 37
        }
      },
      "15": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 15
        }
      },
      "16": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "createHash",
        decl: {
          start: {
            line: 1,
            column: 24
          },
          end: {
            line: 1,
            column: 34
          }
        },
        loc: {
          start: {
            line: 1,
            column: 45
          },
          end: {
            line: 34,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 13,
            column: 11
          }
        }, {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 16,
            column: 11
          }
        }, {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 11
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 18,
            column: 12
          },
          end: {
            line: 18,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 18,
            column: 18
          },
          end: {
            line: 18,
            column: 32
          }
        }, {
          start: {
            line: 18,
            column: 35
          },
          end: {
            line: 18,
            column: 37
          }
        }],
        line: 18
      },
      "2": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        }, {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        }],
        line: 22
      },
      "3": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 37
          }
        }, {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 37
          }
        }],
        line: 23
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export default function createHash(obj) {
  cov_2j7u0d7289.f[0]++;
  var hash = (cov_2j7u0d7289.s[0]++, 0);
  var i;
  var chr;
  var len;
  var str;
  var type = (cov_2j7u0d7289.s[1]++, typeof obj);
  cov_2j7u0d7289.s[2]++;

  switch (type) {
    case 'object':
      cov_2j7u0d7289.b[0][0]++;
      cov_2j7u0d7289.s[3]++;
      str = JSON.stringify(obj);
      cov_2j7u0d7289.s[4]++;
      break;

    case 'string':
      cov_2j7u0d7289.b[0][1]++;
      cov_2j7u0d7289.s[5]++;
      str = obj;
      cov_2j7u0d7289.s[6]++;
      break;

    default:
      cov_2j7u0d7289.b[0][2]++;
      cov_2j7u0d7289.s[7]++;
      str = obj ? (cov_2j7u0d7289.b[1][0]++, obj.toString()) : (cov_2j7u0d7289.b[1][1]++, '');
      cov_2j7u0d7289.s[8]++;
      break;
  }

  cov_2j7u0d7289.s[9]++;

  if (typeof str === 'string') {
    cov_2j7u0d7289.b[2][0]++;
    cov_2j7u0d7289.s[10]++;

    if (str.length === 0) {
      cov_2j7u0d7289.b[3][0]++;
      cov_2j7u0d7289.s[11]++;
      return hash;
    } else {
      cov_2j7u0d7289.b[3][1]++;
    }

    cov_2j7u0d7289.s[12]++;

    for (i = 0, len = str.length; i < len; i++) {
      cov_2j7u0d7289.s[13]++;
      chr = str.charCodeAt(i); // eslint-disable-next-line

      cov_2j7u0d7289.s[14]++;
      hash = (hash << 5) - hash + chr; // eslint-disable-next-line

      cov_2j7u0d7289.s[15]++;
      hash |= 0; // Convert to 32bit integer
    }
  } else {
    cov_2j7u0d7289.b[2][1]++;
  }

  cov_2j7u0d7289.s[16]++;
  return hash.toString(36);
}